import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Datenschutzhinweise
        </h1>
        <p className="text-gray-500 mb-8">Version: 12.03.2026</p>

        <div className="prose prose-gray max-w-none">
          {/* 1. Verantwortlicher */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Verantwortlicher
            </h2>
            <p className="mb-4">
              Verantwortlich nach Art. 4 Nr. 7 DSGVO: Ivelion Health GmbH ,
              Altensteinstraße 40, 14195 Berlin, Deutschland (nachfolgend
              „wir"). Kontakt:{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>
              .
            </p>
          </section>

          {/* 2. Zweck, Art der Dienste */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Zwecke der Verarbeitung
            </h2>
            <p className="mb-4">
              Bereitstellung und Betrieb der Ivelion-Plattform inkl.
              MS-Chatbot, Missbrauchsvermeidung, IT-Sicherheit, Support,
              Qualitätsverbesserung. Bei Eingabe gesundheitsbezogener
              Informationen verarbeiten wir diese zur Antwortgenerierung. Zur
              Auswertung des Forschungsprojektes werden anonymisiert jene Daten
              erhoben, die freiwillig vom Nutzer angegeben werden. Hierzu
              gehören beispielsweise Indikation, Geschlecht, Alter, Interesse an
              Studien oder anderen spezifischen Angeboten. Diese Daten werden im
              Rahmen des Forschungsprojektes aggregiert und analysiert.
              Anschließend werden die Auswertungsergebnisse wissenschaftlich
              publiziert. Die analysierten und publizierten Daten sind
              anonymisiert und können nicht mit Deiner Person in Verbindung
              gebracht werden.
            </p>
            <p className="mb-4">
              Zur Verbesserung der Nutzererfahrung ermitteln wir zu Beginn einer
              Chat-Sitzung Ihre ungefähre geografische Position (Stadt,
              Bundesland und Koordinaten) basierend auf Ihrer IP-Adresse. Diese
              Information hilft uns dabei, Sie mit nahegelegenen klinischen
              Studienzentren zu verbinden, die Entfernung zu Studienzentren zu
              berechnen, und die geografische Verteilung unserer Nutzer zu
              analysieren. Die IP-Adresse selbst wird nicht gespeichert; wir
              speichern nur die abgeleiteten Standortdaten.
            </p>
          </section>

          {/* 3. Rechtsgrundlagen */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Rechtsgrundlagen
            </h2>
            <ul className="mb-4">
              <li>
                Art. 6 Abs. 1 lit. b DSGVO: Vertrag/bereitgestellte Funktionen
                bei registrierten Nutzer:innen.
              </li>
              <li>
                Art. 6 Abs. 1 lit. f DSGVO: Betrugs-/Missbrauchsabwehr, Logs,
                Basis-Analytics (nur minimal, falls berechtigt).
              </li>
              <li>
                Art. 6 Abs. 1 lit. c DSGVO: Rechtspflichten (z. B.
                Nachweispflichten, Sicherheitsvorfälle).
              </li>
              <li>
                Art. 6 Abs. 1 lit. a i. V. m. Art. 9 Abs. 2 lit. a DSGVO:
                ausdrückliche Einwilligung für Gesundheitsdaten und optionale
                Features.
              </li>
            </ul>
          </section>

          {/* 4. Datenkategorien */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Kategorien personenbezogener Daten
            </h2>
            <ul className="mb-4">
              <li>
                <strong>Nutzungs-/Technikdaten:</strong> Ungefähre Standortdaten
                (Stadt, Bundesland und Koordinaten, abgeleitet aus IP-Adresse zu
                Beginn der Chat-Sitzung), Zeitstempel, Geräte-/Browserdaten,
                Logfiles. Die IP-Adresse selbst wird nicht dauerhaft
                gespeichert.
              </li>
              <li>
                <strong>Kontodaten:</strong> Name, E-Mail, Passwort-Hash (bei
                Registrierung).
              </li>
              <li>
                <strong>Chat-Inhalte:</strong> Eingaben und generierte
                Antworten; können Gesundheitsdaten enthalten.
              </li>
              <li>
                <strong>E-Mail-Entwürfe:</strong> Betreff/Inhalt,
                Empfängerangaben, Metadaten.
              </li>
              <li>
                <strong>Cookies/Local Storage:</strong> technisch notwendige
                Session-IDs.
              </li>
            </ul>
          </section>

          {/* 5. Anonyme Nutzung */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Anonyme Nutzung
            </h2>
            <p className="mb-4">
              Nutzung ohne Konto ist möglich. Anonyme Sessions werden nicht mit
              Konten zusammengeführt. Minimierte Sicherheitslogs fallen an.
            </p>
          </section>

          {/* 6. Speicherdauer */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Speicherdauer
            </h2>
            <ul className="mb-4">
              <li>
                Chat-Inhalte: Werden für die Dauer der Nutzung und darüber
                hinaus zum Betrieb, zur Verbesserung des Dienstes und zu
                Forschungszwecken gespeichert. Anonymisierte Chatinhalte ohne
                Personenbezug (wie die Indikation, um die es ging oder die
                Studie, an der Interesse gezeigt wurde), werden darüber hinaus
                zu Forschungszwecken aufgenommen und analysiert. Du kannst
                jederzeit die Löschung deiner Chat-Inhalte gemäß Art. 17 DSGVO
                verlangen.
              </li>
              <li>
                Kontodaten: für die Dauer des Kontos; nach Kontolöschung
                endgültige Löschung der personenbezogenen Daten innerhalb von
                30 Tagen.
              </li>
              <li>
                Logs/Sicherheitsdaten: 30 Tage, nur zu
                Sicherheits-/Fehlerzwecken.
              </li>
            </ul>
            <p className="mb-0">
              Gesetzliche Aufbewahrungspflichten bleiben unberührt.
            </p>
          </section>

          {/* 7. Empfänger / Auftragsverarbeiter */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Empfänger und Auftragsverarbeiter
            </h2>
            <p className="mb-4">
              Wir setzen Dienstleister nach Art. 28 DSGVO ein (AVV
              abgeschlossen). Kategorien:
            </p>
            <ul className="mb-4">
              <li>Hosting/Cloud: AWS, in europäischer Zone.</li>
              <li>KI-/Modell-Infrastruktur: Google.</li>
            </ul>
          </section>

          {/* 8. Sicherheit */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Sicherheit
            </h2>
            <ul className="mb-4">
              <li>
                Verschlüsselung in Transit (TLS) und - soweit möglich - at rest.
              </li>
              <li>
                Rollen-/Rechtekonzept (Need-to-know), Zugriffprotokollierung.
              </li>
              <li>
                Regelmäßige Updates, Backups, Schwachstellen- und ggf.
                Pen-Tests.
              </li>
            </ul>
          </section>

          {/* 9. Cookies/Tracking */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. Cookies und ähnliche Technologien
            </h2>
            <p className="mb-4">
              Wir nutzen technisch notwendige Cookies (z. B. Session, CSRF,
              Load-Balancing).
            </p>
          </section>

          {/* 10. Automatisierte Entscheidungen */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              10. Automatisierte Entscheidungen/Profiling
            </h2>
            <p className="mb-0">
              Es finden keine automatisierten Einzelentscheidungen mit
              Rechtswirkung statt. Personalisierungen (z. B. gespeicherte
              Präferenzen) erfolgen nur mit Einwilligung.
            </p>
          </section>

          {/* 11. Rechte der Betroffenen */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              11. Deine Rechte
            </h2>
            <ul className="mb-4">
              <li>
                Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art.
                17), Einschränkung (Art. 18).
              </li>
              <li>Datenübertragbarkeit (Art. 20 DSGVO).</li>
              <li>
                Widerspruch gegen Verarbeitungen auf Basis von Art. 6 Abs. 1
                lit. f DSGVO (Art. 21).
              </li>
              <li>
                Widerruf von Einwilligungen jederzeit mit Wirkung für die
                Zukunft (Art. 7 Abs. 3).
              </li>
              <li>
                Beschwerderecht bei einer Aufsichtsbehörde, z. B. an deinem
                Wohnsitz oder am Sitz des Verantwortlichen.
              </li>
            </ul>
            <p className="mb-0">
              Kontakt für Rechtewahrnehmung:{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>
            </p>
          </section>

          {/* 12. Minderjährige */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              12. Minderjährige
            </h2>
            <p className="mb-0">
              Der Dienst richtet sich an Personen ab 16 Jahren. Jüngere Personen
              benötigen die Zustimmung der Erziehungsberechtigten.
            </p>
          </section>

          {/* 13. Datenquellen (falls nicht direkt von Nutzer) */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              13. Datenquellen
            </h2>
            <p className="mb-0">
              Daten stammen überwiegend direkt von dir. Technische Daten fallen
              bei Nutzung unserer Systeme an. Keine verdeckte
              Drittquellenerhebung.
            </p>
          </section>

          {/* 14. DPIA / Relevanter Hinweis */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              14. Datenschutz-Folgenabschätzung
            </h2>
            <p className="mb-0">
              Aufgrund der möglichen Verarbeitung von Gesundheitsdaten prüfen
              wir eine Datenschutz-Folgenabschätzung (Art. 35 DSGVO) und
              aktualisieren diese bei wesentlichen Änderungen.
            </p>
          </section>

          {/* 15. Änderungen der Hinweise */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              15. Änderungen dieser Hinweise
            </h2>
            <p className="mb-0">
              Wir passen diese Hinweise an, wenn sich Prozesse ändern oder neue
              Dienste hinzukommen. Die aktuelle Fassung ist jederzeit in der App
              unter /privacy abrufbar.
            </p>
          </section>

          {/* 16. Kontakt/Impressumskern */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              16. Kontakt
            </h2>
            <p className="mb-4">
              Ivelion Health GmbH <br /> E-Mail:{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>{" "}
              <br />
              Anschrift: Altensteinstraße 40, 14195 Berlin, Deutschland
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex items-center justify-between">
          <Link
            to="/terms"
            className="text-purple-600 hover:text-purple-700 font-medium"
          >
            ← Nutzungsbedingungen
          </Link>
          <Link
            to="/"
            className="text-purple-600 hover:text-purple-700 font-medium"
          >
            Zurück zum Chat →
          </Link>
        </div>
      </div>
    </div>
  );
}
